<template>
  <v-app id="inspire">
    <div class="text-center ;">
      <v-dialog v-model="dialog" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2">
            Mensagem
          </v-card-title>

          <v-card-text> Usuário ou senha inválidos </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialog = false"> OK </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <!-- src="https://firebasestorage.googleapis.com/v0/b/apptmcsolar.appspot.com/o/APP3.png?alt=media&token=1a2f2431-a0b3-4a2f-ba9c-9cfda9c7ec68" -->

              <v-img
                src="@/assets/img/loginCover.png"
                class="white--text align-end"
                style="height: 300px; width: 100%; margin: 0px"
              >
              </v-img>

              <br /><br />
              <!-- <v-toolbar dark color="primary">
                        <v-toolbar-title>Login form</v-toolbar-title>
                     </v-toolbar> -->
              <v-card-text>
                <v-form>
                  <v-text-field
                    v-model="email"
                    prepend-icon="mdi-account"
                    name="email"
                    label="Login"
                    type="text"
                    ref="email"
                  ></v-text-field>
                  <v-text-field
                    v-model="password"
                    id="password"
                    prepend-icon="mdi-lock"
                    name="password"
                    label="Password"
                    type="password"
                    ref="password"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- background-image: linear-gradient(to  right, #012935, #012935 ); -->
                <v-btn
                  style="width: 100%"
                  class="primary"
                  @click="doLogin"
                  draggable="true"
                >
                  <b v-show="!loading" style="font-size: 14px">
                    Entrar
                    <v-icon class="ma-1">mdi-login</v-icon>
                  </b>
                  <v-progress-circular
                    v-show="loading"
                    indeterminate
                    color="white"
                  ></v-progress-circular>
                </v-btn>

              </v-card-actions>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-switch class="" v-model ="saveEmail" label="Manter login"> </v-switch>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
export default {
  name: "login",

  data() {
    return {
      saveEmail:false,
      loading: false,
      dialog: false,
      
      //email: process.env.NODE_ENV === "development" ? "thiago@tmcsolar.com.br":'',//hebelautomacao@gmail.com,thiago@tmcsolar.com.br
      //password:process.env.NODE_ENV === "development" ? "123456" : '',//hebel013aut,123456

      //email: process.env.NODE_ENV === "development" ? "hebelautomacao@gmail.com":'',//hebelautomacao@gmail.com,thiago@tmcsolar.com.br
      //password:process.env.NODE_ENV === "development" ? "hebel013aut" : '',//hebel013aut,123456

      //email: process.env.NODE_ENV === "development" ? "phaybla@altrix.com.br":'',//hebelautomacao@gmail.com,thiago@tmcsolar.com.br
      //password:process.env.NODE_ENV === "development" ? "123456" : '',//hebel013aut,123456

      // email: process.env.NODE_ENV === "development" ? "financeiro@badensolar.com.br":'',//hebelautomacao@gmail.com,thiago@tmcsolar.com.br
      // password:process.env.NODE_ENV === "development" ? "badensolar" : '',//hebel013aut,123456

      //email: process.env.NODE_ENV === "development"    ? "lucas@webrazilenergy.com" : "", //hebelautomacao@gmail.com,thiago@tmcsolar.com.br
      //password: process.env.NODE_ENV === "development" ? "b0Dtc2LN" : "", //hebel013aut,123456
      
      
      //email: process.env.NODE_ENV === "development"    ? "vendas@backupenergy.com.br" : "", //hebelautomacao@gmail.com,thiago@tmcsolar.com.br
      //password: process.env.NODE_ENV === "development" ? "123456" : "", //hebel013aut,123456

      // email: process.env.NODE_ENV === "development"    ? "cordeiro@cordeiro.com.br" : "", //hebelautomacao@gmail.com,thiago@tmcsolar.com.br
      // password: process.env.NODE_ENV === "development" ? "cordeiro" : "", //hebel013aut,123456

    //email: process.env.NODE_ENV === "development" ? "sergio@planet.com":'',//hebelautomacao@gmail.com,thiago@tmcsolar.com.br
      //password:process.env.NODE_ENV === "development" ? "planet" : '',//hebel013aut,123456

      email: process.env.NODE_ENV === "development" ? "hebel@tmcsolar.com.br":'',//hebelautomacao@gmail.com,thiago@tmcsolar.com.br
      password:process.env.NODE_ENV === "development" ? "hebel013aut" : '',//hebel013aut,123456


      loading: false,
    };
  },
  created() {
    //Store firebase
    //this.$dao.firebase = this.$firebase;
    this.$session.start();
  },

  mounted(){
    //alert(localStorage.email)
    if(localStorage.email)
      this.email = localStorage.email;

    this.saveEmail = localStorage.saveEmail;

  },
  methods: {
    async doLogin() {
      //alert(this.password)
      this.loading = true;

      const { email, password } = this;
      try {
        const res = await this.$firebase
          .auth()
          .signInWithEmailAndPassword(email, password);
        console.log(res);
        window.uid = res.user.uid;
        //var u =  await this.$dao.getUser(window.uid);
        var u = await this.getUser(window.uid);


        this.$session.set("user", u[0]);
        window.user = u[0];

        //alert(JSON.stringify(u));
        if (u.length == 0) {
          alert("Aguarda autorização");
          return;
        }
        window.eid = u[0].enterpriseId;
        this.$session.set("uid", window.uid);
        this.$session.set("eid", window.eid);

        //var enterprise = await this.$dao.getEnterprise(window.eid);
        var enterprise = await this.getEnterprise(window.eid);

        //alert(enterprise.style.primary)
        if (enterprise.style && enterprise.style.primary) {
          this.$vuetify.theme.themes.light.primary = enterprise.style.primary;
          this.$session.set("primary", enterprise.style.primary);
        }
        if (enterprise.style && enterprise.style.secondary) {
          this.$vuetify.theme.themes.light.secondary =
            enterprise.style.secondary;
          this.$session.set("secondary", enterprise.style.secondary);
        }
        if (enterprise.style && enterprise.style.images) {
          this.$session.set("images", enterprise.style.images);
        } else {
          this.$session.set("images", {
            logo:
              "https://firebasestorage.googleapis.com/v0/b/hebelsolar.appspot.com/o/hebel%2FlogoDark.png?alt=media&token=1f1ccfdd-f077-4ce9-8d33-0aa6aca10fa7",
            logoWhite:
              "https://firebasestorage.googleapis.com/v0/b/hebelsolar.appspot.com/o/hebel%2FlogoWhite.png?alt=media&token=ee04c64c-4ab6-454d-8152-970016298a6a",
          });
        }

        if(this.saveEmail){
          localStorage.email = email;
          localStorage.saveEmail = this.saveEmail;
        }

          if((enterprise.style)&&(!enterprise.style.deals)){   
              enterprise.style.deals = {
              label:{
                singular:"Negócio",
                plural:"Negócios"
              }
            }
          }
    
        

         window.style = enterprise.style;
          // enterprise.style;
         //alert(JSON.stringify(window.style))

        //this.$router.push({name:"Dashboard"})
        this.$router.push("/user");
      } catch (err) {
        console.log(err);
        let message = "";

        switch (err.code) {
          case "auth/user-not-found":
            message = "Não foi possível realizar o usuário";
            break;
          case "auth/wrong-password":
            message = "Senha inválida";
            break;
          default:
            message = "Não foi possível fazer o login";
        }

        //this.$root.$emit("Notification::show", { type:'danger', message:message }  )
        this.dialog = true;
      }
      this.loading = false;
    },
    async getUser(uid) {
      const db = this.$firebase.firestore();
      let objects = [];
      var ans = await db
        .collection("/users")
        .where("uid", "==", uid)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            objects.push(doc.data());
            console.log(doc.id, " => ", doc.data());
          });
          for (var a = 0; a < objects.length; a++) console.log("will return");
          return objects;
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
          return error;
        });
      for (var a = 0; a < ans.length; a++)
        ans[a].enterprise = await this.getEnterprise(ans[a].enterpriseId);

        var profile=   {
          id:'admin',
          name:'Administrador',
          access:{
                  appearance:true,
                  enterprise:true,
                  products:true,
                  fields:true,
                  allContacts:true, //False == only owner,
                  efficiency:true,
                  unitCost:true,
                  unitPrice:true,
                  discount:true
          }
        };
                
        if (!ans[0].profile){
            ans[0].profile = profile;
            ans[0].profileId = profile.id;
        }

      return ans;
    },

    async getEnterprise(id) {
      console.log("getEnterprise:" + id);
      const db = this.$firebase.firestore();
      let objects = [];
      var e = await db
        .collection("/enterprises")
        .where("id", "==", id)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            var d = doc.data();
            d.id = doc.id;
            objects.push(doc.data());

            console.log(doc.id, " => ", doc.data());
          });
          console.log("will return");
          console.log(JSON.stringify(objects));
          return objects[0];
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
          return error;
        });

      console.log(JSON.stringify(e));
      return e;
    },
  },
};
</script>

<style lang="scss" scoped>
//.form-login{
//    display: flex;
//    justify-content: center;
//    align-items: center;
//    height: 100vh;
//}
//.card{
//    width: 30vw;
//    min-width: 300px;
//color: var(--darker);
//}
//h1{
//    font-size:18pt
//}
</style>